import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Card, CardBody, Row, Col, Container, Button, Form, FormText, Label, Input, UncontrolledTooltip, FormGroup } from "reactstrap";
import MetaTags from "react-meta-tags";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import './BusinessProfile.css';
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";

import Cropper from 'react-easy-crop';
import { getCroppedImg } from '../BaseUrl/BPCropper';

const axiosInstance = axios.create();

const mapContainerStyle = {
  height: "400px",
  width: "100%",
};

const CANADA_COORDINATES = { lat: 43.6511, lng: -79.3470 };

const BPEdit = () => {
  const [businessData, setBusinessData] = useState(null);
  const [isGeocoding, setIsGeocoding] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  const [imageToCrop, setImageToCrop] = useState(null);
  const [cropType, setCropType] = useState(null);


  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);



  const [fileInputKey, setFileInputKey] = useState({
    banner: Date.now(),
    logo: Date.now()
  });
  const [touched, setTouched] = useState({
    businessName: false,
    fullAddress: false,
  });
  const [formData, setFormData] = useState({
    businessName: "",
    businessDescription: "",
    telegramLink: "",
    phone: "",
    operatingHours: "",
    instagramId: "",
    longitude: null,
    latitude: null,
    type: "Point",
    streetAddress: "",
    postalCode: "",
    city: "",
    state: "",
    fullAddress: "",
    bannerPhoto: null,
    bannerPhotoUrl: "",
    logoPhoto: null,
    logoPhotoUrl: "",
    googleBusinessLink: "",
    websiteLink: "",
    dailySpecialTime: "",
    lunchSpecialTime: "",
    removeLogo: false,
    removeBanner: false
  });
  const [selectedPosition, setSelectedPosition] = useState(null);
  const history = useHistory();
  const [mapCenter, setMapCenter] = useState(CANADA_COORDINATES);
  const [fieldErrors, setFieldErrors] = useState({});
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [isConnectingInstagram, setIsConnectingInstagram] = useState(false);
  const [instaConnected, setInstaConnected] = useState(false)

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyC9LWOIEmcz4y1chuXAUAGnQFC7zVuLGpc',
  });

  const handleConnectInstagram = async () => {
    if (instaConnected) {
      toast.info("Instagram is already connected.");
      return;
    }

    const token = localStorage.getItem("accessToken");
    if (!token) {
      toast.error("No authentication token found. Please log in.");
      return;
    }

    setIsConnectingInstagram(true);

    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BASE_URL}instagram`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const { responseCode, responseData, responseMessage } = response.data;



      if (String(responseCode) === "200" && responseData?.oauthUrl) {

        // Redirect to Instagram OAuth URL
        window.location.href = responseData.oauthUrl;
      } else {
        toast.error(responseMessage?.[0] || "Failed to generate Instagram OAuth URL");
        setIsConnectingInstagram(false);
      }
    } catch (err) {
      console.error("Instagram connect error:", err);
      const errorMessage =
        err.response?.data?.responseMessage?.[0] ||
        err.message ||
        "Failed to connect Instagram";
      toast.error(errorMessage);
      setIsConnectingInstagram(false);
    }
  };

  const handleInstagramCallback = async (code, state, token) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}instagram/callback`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ code, state }),
          redirect: 'follow'
        }
      );

      const data = await response.json();
      const { responseCode, responseData, responseMessage } = data;

      if (String(responseCode) === "200" && responseData?.longLivedToken) {
        const longLivedToken = responseData.longLivedToken.longLivedToken;
        toast.success(
          `${responseMessage?.[0] || "Instagram Connected Successfully!"}\n\nToken: ${longLivedToken}`,
          {
            autoClose: 10000,
            style: { whiteSpace: 'pre-line' }
          }
        );

        // Refresh business profile to get updated Instagram info
        fetchBusinessProfile(token);
      } else {
        toast.error(responseMessage?.[0] || "Failed to connect Instagram");
      }
    } catch (err) {
      console.error("Instagram callback error:", err);
      const errorMessage = err.message || "Failed to process Instagram connection";
      toast.error(errorMessage);
    }
  };

  const fetchBusinessProfile = async (token) => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}business/profile`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      const business = response.data?.responseData?.business;

      if (!business) {
        setBusinessData(null);
        setFormData({
          businessName: "",
          businessDescription: "",
          telegramLink: "",
          phone: "",
          operatingHours: "",
          instagramId: "",
          longitude: null,
          latitude: null,
          type: "Point",
          streetAddress: "",
          postalCode: "",
          city: "",
          state: "",
          fullAddress: "",
          bannerPhoto: null,
          bannerPhotoUrl: "",
          logoPhoto: null,
          logoPhotoUrl: "",
          googleBusinessLink: "",
          websiteLink: "",
          dailySpecialTime: "",
          lunchSpecialTime: "",
          removeLogo: false,
          removeBanner: false,
        });
        setLoading(false);
        return;
      }

      // Check if Instagram is already connected
      if (business?.instagramInfo?.instagramToken) {
        setInstaConnected(true);

      }

      setBusinessData(business);

      const coordinates = business.businessLocation?.coordinates || [null, null];
      const streetAddress = business.businessLocation?.streetAddress || "";
      const postalCode = business.businessLocation?.postalCode || "";
      const city = business.businessLocation?.city || "";
      const state = business.businessLocation?.state || "";

      const addressParts = [];
      if (streetAddress) addressParts.push(streetAddress);
      if (city) addressParts.push(city);
      if (state) addressParts.push(state);
      if (postalCode) addressParts.push(postalCode);
      const fullAddress = addressParts.join(", ");

      setFormData({
        businessName: business.businessName || "",
        businessDescription: business.businessDescription || "",
        telegramLink: business.telegramLink || "",
        phone: business.phone || "",
        operatingHours: business.operatingHours || "",
        instagramId: business.instagramId || "",
        longitude: coordinates[0] ? parseFloat(coordinates[0]) : null,
        latitude: coordinates[1] ? parseFloat(coordinates[1]) : null,
        type: "Point",
        streetAddress: streetAddress,
        postalCode: postalCode,
        city: city,
        state: state,
        fullAddress: fullAddress,
        bannerPhoto: null,
        bannerPhotoUrl: business.bannerImage?.url || "",
        logoPhoto: null,
        logoPhotoUrl: business.logoImage?.url || "",
        googleBusinessLink: business.googleBusinessLink || "",
        websiteLink: business.websiteLink || "",
        dailySpecialTime: business.dailySpecialTime || "",
        lunchSpecialTime: business.lunchSpecialTime || "",
        removeLogo: false,
        removeBanner: false,
      });

      if (coordinates[0] && coordinates[1]) {
        setMapCenter({
          lat: parseFloat(coordinates[1]),
          lng: parseFloat(coordinates[0]),
        });
        setSelectedPosition({
          lat: parseFloat(coordinates[1]),
          lng: parseFloat(coordinates[0]),
        });
      } else {
        setMapCenter(CANADA_COORDINATES);
        setSelectedPosition(null);
      }

      setLoading(false);
    } catch (err) {
      setBusinessData(null);
      setFormData({
        businessName: "",
        businessDescription: "",
        telegramLink: "",
        phone: "",
        operatingHours: "",
        instagramId: "",
        longitude: null,
        latitude: null,
        type: "Point",
        streetAddress: "",
        postalCode: "",
        city: "",
        state: "",
        fullAddress: "",
        bannerPhoto: null,
        bannerPhotoUrl: "",
        logoPhoto: null,
        logoPhotoUrl: "",
        googleBusinessLink: "",
        websiteLink: "",
        dailySpecialTime: "",
        lunchSpecialTime: "",
        removeLogo: false,
        removeBanner: false,
      });
      setLoading(false);
    }
  };




  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      setError("No authentication token found. Please log in.");
      toast.error("No authentication token found. Please log in.");
      history.push("/login");
      return;
    }

    fetchBusinessProfile(token);

    // Handle Instagram OAuth callback
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');

    if (code && state) {
      // Clean up URL first to avoid re-triggering
      window.history.replaceState({}, document.title, window.location.pathname);
      // Then handle the callback
      handleInstagramCallback(code, state, token);
    }
  }, [history]);

  const geocodeAddress = useCallback(async (address) => {
    if (!isLoaded || !address.trim()) {
      setMapCenter(CANADA_COORDINATES);
      setSelectedPosition(null);
      setFormData(prev => ({
        ...prev,
        longitude: null,
        latitude: null,
        streetAddress: "",
        postalCode: "",
        city: "",
        state: "",
        fullAddress: address
      }));
      return;
    }

    try {
      setIsGeocoding(true);
      const geocoder = new window.google.maps.Geocoder();
      const results = await new Promise((resolve, reject) => {
        geocoder.geocode({ address }, (results, status) => {
          if (status === "OK") resolve(results);
          else reject(status);
        });
      });

      if (results[0]) {
        const location = results[0].geometry.location;
        const lat = location.lat();
        const lng = location.lng();
        const addressComponents = results[0].address_components;

        const getComponent = (type) => {
          const component = addressComponents.find((c) => c.types.includes(type));
          return component ? component.long_name : "";
        };

        const streetNumber = getComponent("street_number");
        const route = getComponent("route");
        const city = getComponent("locality") || getComponent("administrative_area_level_2");
        const postalCode = getComponent("postal_code");
        const state = getComponent("administrative_area_level_1");
        const fullAddress = results[0].formatted_address;


        setFormData(prev => ({
          ...prev,
          longitude: lng,
          latitude: lat,
          streetAddress: `${streetNumber} ${route}`.trim(),
          city: city,
          postalCode: postalCode,
          state: state,
          fullAddress: fullAddress
        }));

        setSelectedPosition({ lat, lng });
        setMapCenter({ lat, lng });
      } else {
        toast.error("No results found for this address.");
      }
    } catch (error) {
      // toast.error(`Failed to geocode address: ${error}`);
      setFormData(prev => ({
        ...prev,
        fullAddress: address
      }));
    } finally {
      setIsGeocoding(false);
    }
  }, [isLoaded]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      const numericValue = value.replace(/[^0-9]/g, '').slice(0, 15);
      setFormData(prev => ({
        ...prev,
        phone: numericValue
      }));
    } else if (name === "fullAddress") {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }

      setFormData(prev => ({
        ...prev,
        [name]: value
      }));

      setTypingTimeout(
        setTimeout(() => {
          if (!isGeocoding) {
            geocodeAddress(value);
          }
        }, 1000)
      );
    } else if (name === "streetAddress" || name === "city" || name === "postalCode" || name === "state") {
      setFormData(prev => {
        const newData = {
          ...prev,
          [name]: value
        };
        const addressParts = [];
        if (newData.streetAddress) addressParts.push(newData.streetAddress);
        if (newData.city) addressParts.push(newData.city);
        if (newData.state) addressParts.push(newData.state);
        if (newData.postalCode) addressParts.push(newData.postalCode);
        const fullAddress = addressParts.join(", ");
        return {
          ...newData,
          fullAddress: fullAddress
        };
      });
    } else if (name === "longitude" || name === "latitude") {
      if (value === "") {
        setFormData(prev => ({
          ...prev,
          [name]: null
        }));
        return;
      }

      const numValue = parseFloat(value);
      if (isNaN(numValue)) {
        toast.error(`Please enter a valid number for ${name}`);
        return;
      }

      setFormData(prev => ({
        ...prev,
        [name]: numValue
      }));

      if ((name === "latitude" && formData.longitude !== null) ||
        (name === "longitude" && formData.latitude !== null)) {
        setSelectedPosition({
          lat: name === "latitude" ? numValue : formData.latitude,
          lng: name === "longitude" ? numValue : formData.longitude
        });
        setMapCenter({
          lat: name === "latitude" ? numValue : formData.latitude,
          lng: name === "longitude" ? numValue : formData.longitude
        });
      }
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }

    if (fieldErrors[name]) {
      setFieldErrors(prev => ({ ...prev, [name]: false }));
    }
  };

  // const handleBannerPhotoChange = (e) => {
  //   setFormData(prev => ({
  //     ...prev,
  //     bannerPhoto: e.target.files[0],
  //     bannerPhotoUrl: e.target.files[0] ? URL.createObjectURL(e.target.files[0]) : prev.bannerPhotoUrl,
  //     removeBanner: false
  //   }));
  //   setFileInputKey(prev => ({ ...prev, banner: Date.now() }));
  // };

  // const handleLogoPhotoChange = (e) => {
  //   setFormData(prev => ({
  //     ...prev,
  //     logoPhoto: e.target.files[0],
  //     logoPhotoUrl: e.target.files[0] ? URL.createObjectURL(e.target.files[0]) : prev.logoPhotoUrl,
  //     removeLogo: false
  //   }));
  //   setFileInputKey(prev => ({ ...prev, logo: Date.now() }));
  // };


  const handleFileChange = (type) => (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        setImageToCrop(reader.result);
        setCropType(type);
        setShowCropper(true);
        e.target.value = '';
      });
      reader.readAsDataURL(file);
    }
  };


  const handleCropComplete = async () => {
    try {
      // Pass target dimensions only if cropType is banner
      const croppedImageBlob = await getCroppedImg(
        imageToCrop,
        croppedAreaPixels,
        cropType
      );

      const fileName = cropType === "banner" ? "banner.jpg" : "logo.png";
      const mimeType = cropType === "banner" ? "image/jpeg" : "image/png";

      const croppedImageFile = new File([croppedImageBlob], fileName, {
        type: mimeType,
      });

      if (cropType === "banner") {
        setFormData((prev) => ({
          ...prev,
          bannerPhoto: croppedImageFile,
          bannerPhotoUrl: URL.createObjectURL(croppedImageBlob),
          removeBanner: false,
        }));
        setFileInputKey((prev) => ({ ...prev, banner: Date.now() }));
      } else {
        setFormData((prev) => ({
          ...prev,
          logoPhoto: croppedImageFile,
          logoPhotoUrl: URL.createObjectURL(croppedImageBlob),
          removeLogo: false,
        }));
        setFileInputKey((prev) => ({ ...prev, logo: Date.now() }));
      }

      setShowCropper(false);
    } catch (e) {
      toast.error("Error cropping image");
    }
  };


  const handleRemoveBanner = () => {
    setFormData(prev => ({
      ...prev,
      bannerPhoto: null,
      bannerPhotoUrl: "",
      removeBanner: true
    }));
    setFileInputKey(prev => ({ ...prev, banner: Date.now() }));
  };

  const handleRemoveLogo = () => {
    setFormData(prev => ({
      ...prev,
      logoPhoto: null,
      logoPhotoUrl: "",
      removeLogo: true
    }));
    setFileInputKey(prev => ({ ...prev, logo: Date.now() }));
  };

  const handleMapClick = async (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();

    setSelectedPosition({ lat, lng });
    setMapCenter({ lat, lng });

    setFormData(prev => ({
      ...prev,
      longitude: lng,
      latitude: lat
    }));

    if (fieldErrors.fullAddress) {
      setFieldErrors(prev => ({ ...prev, fullAddress: false }));
    }

    try {
      const geocoder = new window.google.maps.Geocoder();
      const results = await new Promise((resolve, reject) => {
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === "OK") resolve(results);
          else reject(status);
        });
      });

      if (results[0]) {
        const address = results[0];
        const addressComponents = address.address_components;

        const getComponent = (type) => {
          const component = addressComponents.find((c) => c.types.includes(type));
          return component ? component.long_name : "";
        };

        const streetNumber = getComponent("street_number");
        const route = getComponent("route");
        const city = getComponent("locality") || getComponent("administrative_area_level_2");
        const postalCode = getComponent("postal_code");
        const state = getComponent("administrative_area_level_1");
        const fullAddress = address.formatted_address;

        setFormData(prev => ({
          ...prev,
          streetAddress: `${streetNumber} ${route}`.trim(),
          city: city,
          postalCode: postalCode,
          state: state,
          fullAddress: fullAddress
        }));
      } else {
        toast.error("No address found for this location.");
      }
    } catch (error) {
      toast.error(`Failed to fetch address: ${error}`);
    }
  };

  const handleMarkerDragEnd = async (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();

    setSelectedPosition({ lat, lng });
    setMapCenter({ lat, lng });

    setFormData(prev => ({
      ...prev,
      longitude: lng,
      latitude: lat
    }));

    if (fieldErrors.fullAddress) {
      setFieldErrors(prev => ({ ...prev, fullAddress: false }));
    }

    try {
      const geocoder = new window.google.maps.Geocoder();
      const results = await new Promise((resolve, reject) => {
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === "OK") resolve(results);
          else reject(status);
        });
      });

      if (results[0]) {
        const address = results[0];
        const addressComponents = address.address_components;

        const getComponent = (type) => {
          const component = addressComponents.find((c) => c.types.includes(type));
          return component ? component.long_name : "";
        };

        const streetNumber = getComponent("street_number");
        const route = getComponent("route");
        const city = getComponent("locality") || getComponent("administrative_area_level_2");
        const postalCode = getComponent("postal_code");
        const state = getComponent("administrative_area_level_1");
        const fullAddress = address.formatted_address;

        setFormData(prev => ({
          ...prev,
          streetAddress: `${streetNumber} ${route}`.trim(),
          city: city,
          postalCode: postalCode,
          state: state,
          fullAddress: fullAddress
        }));
      } else {
        toast.error("No address found for this location.");
      }
    } catch (error) {
      toast.error(`Failed to fetch address: ${error}`);
    }
  };

  const validateForm = () => {
    const errors = {};
    let isValid = true;

    if (!formData.businessName.trim()) {
      errors.businessName = true;
      isValid = false;
      toast.error("Business Name is required");
    }

    if (!formData.fullAddress.trim() || formData.longitude === null || formData.latitude === null) {
      errors.fullAddress = true;
      isValid = false;
      toast.error("Location is required - please select a location on the map or enter a valid address");
    }

    setFieldErrors(errors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("accessToken");

    if (!token) {
      toast.error("No authentication token found. Please log in.");
      history.push("/login");
      return;
    }

    if (!validateForm()) {
      return;
    }

    try {
      const formPayload = new FormData();

      formPayload.append("businessName", formData.businessName);
      formPayload.append("businessDescription", formData.businessDescription || "");
      formPayload.append("telegramLink", formData.telegramLink || "");
      formPayload.append("phone", formData.phone || "");
      formPayload.append("operatingHours", formData.operatingHours || "");
      formPayload.append("instagramId", formData.instagramId || "");
      formPayload.append("longitude", formData.longitude.toString());
      formPayload.append("latitude", formData.latitude.toString());
      formPayload.append("type", "Point");
      formPayload.append("streetAddress", formData.streetAddress || "");
      formPayload.append("postalCode", formData.postalCode || "");
      formPayload.append("city", formData.city || "");
      formPayload.append("state", formData.state || "");
      formPayload.append("fullAddress", formData.fullAddress || "");
      formPayload.append("googleBusinessLink", formData.googleBusinessLink || "");
      formPayload.append("websiteLink", formData.websiteLink || "");
      formPayload.append("dailySpecialTime", formData.dailySpecialTime || "");
      formPayload.append("lunchSpecialTime", formData.lunchSpecialTime || "");

      if (formData.bannerPhoto) {
        formPayload.append("bannerPhoto", formData.bannerPhoto);
      }
      if (formData.removeBanner) {
        formPayload.append("removeBanner", "true");
      }

      if (formData.logoPhoto) {
        formPayload.append("logoPhoto", formData.logoPhoto);
      }
      if (formData.removeLogo) {
        formPayload.append("removeLogo", "true");
      }

      console.log("FormData Payload:");
      for (let [key, value] of formPayload.entries()) {
        console.log(`${key}: ${value instanceof File ? `(File: ${value.name})` : value}`);
      }

      const response = await axiosInstance.put(
        `${process.env.REACT_APP_BASE_URL}business/profile`,
        formPayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const { responseMessage, responseCode, responseData } = response.data;

      console.log("Backend Response:", response.data);

      if (String(responseCode) !== "200" && String(responseCode) !== "201") {
        throw new Error(responseMessage?.[0] || "Failed to update business profile");
      }

      toast.success(responseMessage?.[0] || "Business profile updated successfully!");

      if (responseData?.subscriptionType) {
        // Subscription info is now handled via API - no need to store in localStorage
      }
      setTimeout(() => {
        history.push("/business-profile");
      }, 1500);
    } catch (err) {
      console.error("Error details:", err);
      const errorMessage =
        err.response?.data?.responseMessage?.[0] ||
        err.message ||
        "Failed to update business profile";
      toast.error(errorMessage);

      if (err.response?.status === 401) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("authUser");
        history.push("/login");
      }
    }
  };

  useEffect(() => {
    return () => {
      if (typingTimeout) {
        clearTimeout(typingTimeout);
      }
    };
  }, [typingTimeout]);

  if (loading) return <div className="bp-loading">Loading...</div>;
  if (error) return <div className="bp-error">{error}</div>;
  if (loadError) return <div className="bp-error">Error loading Google Maps</div>;
  if (!isLoaded) return <div className="bp-loading">Loading Google Maps...</div>;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid className="mt-5">
          <MetaTags>
            <title>Business Profile</title>
          </MetaTags>
          <Row className="align-items-center topbp">
            <Col xl={6} className="d-flex align-items-center">
              <h3 className="bp-title mb-0">Business Profile</h3>
            </Col>
            <Col xl={6} className="d-flex justify-content-end align-items-center">
              <Button

                className="me-2 btn btn-secondary"
                onClick={() => history.push('/business-profile')}
              >
                Back
              </Button>
            </Col>
          </Row>
          <div className="bp-separator"></div>
          <Row>
            <Col xl={12}>
              <div className="bp-wrapper">
                <Form onSubmit={handleSubmit} className="bp-form" encType="multipart/form-data">
                  <div className="margin">
                    <Row className="form-row">
                      <Col md={6} className="form-field-left">
                        <FormGroup>
                          <Label className="updatelabel required-field" for="businessName">
                            Business Name
                          </Label>
                          <Input
                            className={`updateinput ${fieldErrors.businessName ? 'is-invalid' : ''}`}
                            type="text"
                            name="businessName"
                            id="businessName"
                            value={formData.businessName}
                            onChange={handleInputChange}
                            placeholder="Enter business name"
                            onBlur={() => setTouched({ ...touched, businessName: true })}
                            invalid={touched.businessName && !formData.businessName}
                          />
                          {touched.businessName && !formData.businessName && (
                            <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                              Business Name is required
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                      <Col md={6} className="form-field-right">
                        <FormGroup>
                          <Label className="updatelabel" for="phone">
                            Phone Number
                          </Label>
                          <Input
                            className="updateinput"
                            type="tel"
                            name="phone"
                            id="phone"
                            value={formData.phone}
                            onChange={handleInputChange}
                            placeholder="Enter contact number"
                            maxLength={15}
                            pattern="[0-9]*"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="form-row">
                      <Col md={6} className="form-field-left">
                        <FormGroup>
                          <div className="d-flex align-items-center mb-3">
                            <Label className="updatelabel mb-0" for="bannerPhoto">
                              Banner Photo
                            </Label>

                            {/* Tooltip icon OUTSIDE the Label */}
                            <span
                              className="tooltipbtn mb-0 ms-2"
                              id="tooltipTop"
                              style={{ cursor: 'pointer' }}
                              onClick={(e) => e.stopPropagation()} // prevent triggering file input
                            >
                              <i className="fas fa-info-circle text-dark" />
                            </span>

                            <UncontrolledTooltip placement="top" target="tooltipTop">
                              Please upload a banner photo with dimensions of 1152×272 pixels.
                            </UncontrolledTooltip>
                          </div>

                          <Input
                            type="file"
                            name="bannerPhoto"
                            id="bannerPhoto"
                            key={`banner-${fileInputKey.banner}`}
                            onChange={handleFileChange('banner')}
                            accept="image/*"
                          />

                          {formData.bannerPhotoUrl && !formData.removeBanner && (
                            <div className="mt-2">
                              <FormText>Preview Banner:</FormText>
                              <div className="d-flex align-items-center mt-1">
                                <img
                                  src={formData.bannerPhotoUrl}
                                  alt="Current banner"
                                  style={{ maxWidth: '100px', maxHeight: '50px', marginRight: '5px' }}
                                />
                                <Button
                                  size="sm"
                                  className="remove-banner-btn"
                                  onClick={handleRemoveBanner}
                                >
                                  x
                                </Button>
                              </div>
                            </div>
                          )}

                          <FormText>
                            {formData.removeBanner
                              ? " "
                              : formData.bannerPhotoUrl
                                ? formData.bannerPhotoUrl.split('/').pop()
                                : " "}
                          </FormText>
                        </FormGroup>
                      </Col>

                      <Col md={6} className="form-field-right">
                        <FormGroup>
                          <Label className="updatelabel mb-3" for="logoPhoto">
                            Logo Photo
                          </Label>
                          <Input
                            type="file"
                            name="logoPhoto"
                            id="logoPhoto"
                            key={`logo-${fileInputKey.logo}`}
                            onChange={handleFileChange('logo')}
                            accept="image/*"
                          />
                          {formData.logoPhotoUrl && !formData.removeLogo && (
                            <div className="mt-2">
                              <FormText>Preview Logo:</FormText>
                              <div className="d-flex align-items-center mt-1">
                                <img
                                  src={formData.logoPhotoUrl}
                                  alt="Current logo"
                                  style={{ maxWidth: '100px', maxHeight: '50px', marginRight: '5px' }}
                                />
                                <Button
                                  color="danger"
                                  size="sm"
                                  className="remove-banner-btn"
                                  onClick={handleRemoveLogo}
                                >
                                  x
                                </Button>
                              </div>
                            </div>
                          )}
                          <FormText>
                            {formData.removeLogo
                              ? " "
                              : formData.logoPhotoUrl
                                ? `${formData.logoPhotoUrl.split('/').pop()}`
                                : " "}
                          </FormText>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="form-row">
                      <Col md={12} className="form-field-right">
                        <FormGroup>
                          <Label className="updatelabel" for="businessDescription">
                            Business Description
                          </Label>
                          <Input
                            className="updateinput"
                            type="textarea"
                            name="businessDescription"
                            id="businessDescription"
                            value={formData.businessDescription}
                            onChange={handleInputChange}
                            rows="3"
                            placeholder="Enter business description"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} className="form-field-left">
                        <FormGroup>
                          <Label className="updatelabel required-field" for="fullAddress">
                            Location
                          </Label>
                          <Input
                            className={`updateinput ${fieldErrors.fullAddress ? 'is-invalid' : ''}`}
                            type="text"
                            name="fullAddress"
                            id="fullAddress"
                            value={formData.fullAddress}
                            onChange={handleInputChange}
                            placeholder="e.g. 123 Main St, Toronto, ON, M5H 2N2"
                            onBlur={() => setTouched({ ...touched, fullAddress: true })}
                            invalid={touched.fullAddress && !formData.fullAddress}
                          />
                          {touched.fullAddress && !formData.fullAddress && (
                            <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                              Please enter a valid address
                            </div>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} className="form-field-right">
                        <FormGroup>
                          <GoogleMap
                            mapContainerStyle={mapContainerStyle}
                            center={mapCenter}
                            zoom={13}
                            onClick={handleMapClick}
                          >
                            {selectedPosition && (
                              <Marker
                                position={selectedPosition}
                                draggable={true}
                                onDragEnd={handleMarkerDragEnd}
                              />
                            )}
                          </GoogleMap>
                          <div className="coordinates-display mt-2">
                            <span>Latitude: {formData.latitude !== null ? formData.latitude : "Not set"}</span>
                            <span className="ms-3">Longitude: {formData.longitude !== null ? formData.longitude : "Not set"}</span>
                          </div>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="form-row">
                     <Col md={6} className="form-field-left">
  <FormGroup>
    <div className="d-flex align-items-center justify-content-between mb-2">
      <div className="d-flex align-items-center">
        <Label className="updatelabel fw-semibold mb-0" for="instagramId">
          Instagram Link
        </Label>

        <span
          className="tooltipbtn mb-0 ms-2"
          id="tooltipInstagram"
          style={{ cursor: 'pointer' }}
          onClick={(e) => e.stopPropagation()}
        >
          <i className="fas fa-info-circle text-dark" />
        </span>

        <UncontrolledTooltip placement="top" target="tooltipInstagram">
          We'll show your latest Instagram posts on your BiteSaver profile so you don't have to upload photos manually.
        </UncontrolledTooltip>
      </div>

      {/* Button + Tooltip moved to a wrapper to ensure DOM order */}
      <div className="position-relative">
        <Button
          color="primary"
          size="sm"
          className="d-flex align-items-center"
          id="instagramConnectBtn"
          onClick={handleConnectInstagram}
          disabled={isConnectingInstagram || instaConnected}
        >
          {isConnectingInstagram ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Connecting...
            </>
          ) : (
            <>
              <i className="fab fa-instagram me-2 text-white" />
              {instaConnected ? "Connected" : "Connect Instagram"}
            </>
          )}
        </Button>

        {/* Tooltip is now *after* button and in same container */}
        <UncontrolledTooltip placement="top" target="instagramConnectBtn">
          {instaConnected
            ? "Instagram is already connected"
            : "Connect your Instagram to show posts automatically"}
        </UncontrolledTooltip>
      </div>
    </div>

    <Input
      className="updateinput"
      type="text"
      name="instagramId"
      id="instagramId"
      value={formData.instagramId}
      onChange={handleInputChange}
      placeholder="Enter Instagram Handle or Instagram Profile URL"
    />
  </FormGroup>
</Col>

                      <Col md={6} className="form-field-left">
                        <FormGroup>
                          <Label className="updatelabel" for="websiteLink">
                            Website Link
                          </Label>
                          <Input
                            className="updateinput"
                            type="text"
                            name="websiteLink"
                            id="websiteLink"
                            value={formData.websiteLink}
                            onChange={handleInputChange}
                            placeholder="Enter website link"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="form-row">
                      <Col md={6} className="form-field-left">
                        <FormGroup>
                          <Label className="updatelabel" for="operatingHours">
                            Operating Hours
                          </Label>
                          <Input
                            className="updateinput"
                            type="textarea"
                            name="operatingHours"
                            id="operatingHours"
                            value={formData.operatingHours}
                            onChange={handleInputChange}
                            placeholder={`Monday:    10:00 AM - 05:00 PM
Tuesday:   10:00 AM - 05:00 PM
Wednesday: 10:00 AM - 05:00 PM
Thursday:  10:00 AM - 05:00 PM
Friday:    10:00 AM - 05:00 PM
Saturday:  10:00 AM - 05:00 PM
Sunday:    10:00 AM - 05:00 PM`}

                            rows="7"
                          />
                        </FormGroup>
                      </Col>
                      {/* <Col md={6} className="form-field-right">
                        <FormGroup>
                          <Label className="updatelabel" for="googleBusinessLink">
                            Google Business Link
                          </Label>
                          <Input
                            className="updateinput"
                            type="text"
                            name="googleBusinessLink"
                            id="googleBusinessLink"
                            value={formData.googleBusinessLink}
                            onChange={handleInputChange}
                            placeholder="Enter Google Business link"
                          />
                        </FormGroup>
                      </Col> */}
                    </Row>
                    <div className="form-actions">
                      <Button
                        className="me-2 btn btn-secondary"
                        onClick={() => history.push('/business-profile')}
                      >
                        Cancel
                      </Button>
                      <Button color="primary" type="submit">
                        Save Changes
                      </Button>
                    </div>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
          <ToastContainer />
        </Container>
      </div>

      {showCropper && (
        <div className="crop-modal">
          <div className="crop-modal-content">
            <h4>Crop your {cropType === 'banner' ? 'banner' : 'logo'}</h4>
            <div className="crop-container">
              <Cropper
                image={imageToCrop}
                crop={crop}
                zoom={zoom}
                aspect={cropType === 'banner' ? 3 / 1 : 1}
                onCropChange={setCrop}
                onCropComplete={onCropComplete}
                onZoomChange={setZoom}
                cropShape={cropType === 'banner' ? 'rect' : 'round'}
                zoomWithWheel={true}
                minZoom={0.5}
                maxZoom={3}
                wheelSpeed={0.01}
              />
            </div>
            <div className="crop-controls">
              <input
                type="range"
                value={zoom}
                min={0.5}
                max={3}
                step={0.01}
                onChange={(e) => setZoom(e.target.value)}
              />
              <div className="crop-buttons">
                <Button color="secondary" onClick={() => setShowCropper(false)}>
                  Cancel
                </Button>
                <Button color="primary" onClick={handleCropComplete}>
                  Save Crop
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}



    </React.Fragment>
  );
};

export default BPEdit;